// extracted by mini-css-extract-plugin
module.exports = {"CompatibilityTable":"CompatibilityTable_CompatibilityTable__2TeJH"};